import { render, staticRenderFns } from "./ManageAllOccurrences.vue?vue&type=template&id=5251190d&scoped=true&"
import script from "./ManageAllOccurrences.vue?vue&type=script&setup=true&lang=js&"
export * from "./ManageAllOccurrences.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ManageAllOccurrences.vue?vue&type=style&index=0&id=5251190d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5251190d",
  null
  
)

export default component.exports